import { useDatasourceMappingSearch } from "../../../../components/modals/settings/panes/datasource_mapping/search"

import { EmptyView } from "@ciq/shared/components/views"
import { ListView } from "@ciq/shared/components/list"
import { Datasource } from "@ciq/shared/components/datasource_mapping"
import { EntryModal } from "@ciq/shared/components/modal"

import SettingsSearch from "../../../../components/modals/settings/panes/search"
import { useMapViewData } from "@ciq/shared/pages/map/hooks/map_view_data"

export function Mappings({ show, onHide }) {
  const { search, actions: searchActions } = useDatasourceMappingSearch()
  const { datasourceMappings } = useMapViewData()

  const { isLoaded, datasets, hasDatasets, groups, actions: mappingActions } = datasourceMappings

  if (!show) {
    return null
  }

  return (
    <EntryModal
      title="Institution Mapping"
      show={show}
      cardClassName="map-mapping-modal-card"
      bodyClassName="map-mapping-modal-body"
      onHide={onHide}
    >
      <div className="settings-users-list">
        <SettingsSearch search={search.term} onSearch={searchActions.set} />
        {!hasDatasets && (
          <EmptyView>{!isLoaded ? "Loading..." : "No datasources found."}</EmptyView>
        )}
        {hasDatasets && (
          <ListView>
            {datasets.map(dataset => (
              <Datasource
                key={dataset.id}
                dataset={dataset}
                groups={groups}
                actions={mappingActions}
              />
            ))}
          </ListView>
        )}
      </div>
    </EntryModal>
  )
}
